export default __webpack_public_path__ + "static/media/ADIZ_01_mos_MPOL.73a219b9.wav";